import { SVGProps } from 'react';

export const ArchiveBoxIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15"
    fill="none"
    {...props}
  >
    <path
      stroke="#212c3a"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2 4.247a2 2 0 0 1-.293-.026A1.5 1.5 0 0 1 .53 3.043C.5 2.898.5 2.723.5 2.375s0-.523.029-.668A1.5 1.5 0 0 1 1.707.53C1.852.5 2.027.5 2.375.5h11.25c.348 0 .523 0 .668.029a1.5 1.5 0 0 1 1.178 1.178c.029.145.029.32.029.668s0 .523-.029.668a1.5 1.5 0 0 1-1.178 1.178c-.08.016-.17.023-.293.026M6.5 8h3M2 4.25h12v6.15c0 1.26 0 1.89-.245 2.371-.216.424-.56.768-.984.984-.48.245-1.11.245-2.371.245H5.6c-1.26 0-1.89 0-2.371-.245a2.25 2.25 0 0 1-.984-.984C2 12.292 2 11.662 2 10.4z"
    />
  </svg>
);

export const MenuIcon = ({
  isDesktop,
  ...props
}: SVGProps<SVGSVGElement> & { isDesktop: boolean }) =>
  isDesktop ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      fill="none"
      {...props}
    >
      <path
        fill="#FF4F08"
        fillRule="evenodd"
        d="M18.25 1H1.75c-.414 0-.75.392-.75.875 0 .484.336.875.75.875h16.5c.414 0 .75-.391.75-.875 0-.483-.336-.875-.75-.875Zm0 6.123H1.75c-.414 0-.75.392-.75.875 0 .484.336.876.75.876h16.5c.414 0 .75-.392.75-.876 0-.483-.336-.875-.75-.875ZM1.75 13.25h16.5c.414 0 .75.392.75.876 0 .483-.336.875-.75.875H1.75c-.414 0-.75-.392-.75-.875 0-.484.336-.876.75-.876Z"
        clipRule="evenodd"
      />
      <path
        fill="#FF4F08"
        d="M1.75 1.25h16.5v-.5H1.75v.5Zm-.5.625c0-.383.259-.625.5-.625v-.5c-.587 0-1 .541-1 1.125h.5Zm.5.625c-.241 0-.5-.242-.5-.625h-.5C.75 2.46 1.163 3 1.75 3v-.5Zm16.5 0H1.75V3h16.5v-.5Zm.5-.625c0 .383-.259.625-.5.625V3c.587 0 1-.541 1-1.125h-.5Zm-.5-.625c.241 0 .5.242.5.625h.5c0-.584-.413-1.125-1-1.125v.5ZM1.75 7.373h16.5v-.5H1.75v.5Zm-.5.625c0-.383.259-.625.5-.625v-.5c-.587 0-1 .542-1 1.125h.5Zm.5.626c-.241 0-.5-.243-.5-.626h-.5c0 .584.413 1.126 1 1.126v-.5Zm16.5 0H1.75v.5h16.5v-.5Zm.5-.626c0 .383-.259.626-.5.626v.5c.587 0 1-.542 1-1.126h-.5Zm-.5-.625c.241 0 .5.243.5.625h.5c0-.583-.413-1.125-1-1.125v.5Zm0 5.626H1.75v.5h16.5V13Zm1 1.126c0-.584-.413-1.126-1-1.126v.5c.241 0 .5.243.5.626h.5Zm-1 1.125c.587 0 1-.541 1-1.125h-.5c0 .383-.259.625-.5.625v.5Zm-16.5 0h16.5v-.5H1.75v.5Zm-1-1.125c0 .584.413 1.125 1 1.125v-.5c-.241 0-.5-.242-.5-.625h-.5Zm1-1.126c-.587 0-1 .542-1 1.126h.5c0-.383.259-.626.5-.626V13Z"
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="18"
      viewBox="0 0 22 18"
      {...props}
    >
      <g fill="#FF4F08" fillRule="evenodd">
        <g fill="#FF4F08" fillRule="nonzero" stroke="#FF4F08" strokeWidth=".5">
          <path
            d="M19.148 14.509c.46 0 .833.37.833.825 0 .456-.373.825-.833.825h0H.833c-.46 0-.833-.37-.833-.825 0-.456.373-.825.833-.825h0zm0-7.253c.46 0 .833.37.833.825 0 .456-.373.826-.833.826h0H.833c-.46 0-.833-.37-.833-.826 0-.456.373-.825.833-.825h0zm0-7.253c.46 0 .833.37.833.825 0 .456-.373.826-.833.826h0H.833c-.46 0-.833-.37-.833-.826C0 .373.373.003.833.003h0z"
            transform="translate(-14 -214) translate(0 192) translate(15 23)"
          />
        </g>
      </g>
    </svg>
  );

export const CloseDesktopMenuIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 16"
    width={20}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#FF4F08"
      transform="translate(3, 1)"
      d="M14 1.217 12.783 0 7 5.783 1.217 0 0 1.217 5.783 7 0 12.783 1.217 14 7 8.217 12.783 14 14 12.783 8.217 7 14 1.217Z"
    />
  </svg>
);

export const CloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 15}
    height={props.height || props.width || 15}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Back">
      <path
        id="Shape"
        d="M15 1.30419L13.6958 0L7.5 6.19581L1.30419 0L0 1.30419L6.19581 7.5L0 13.6958L1.30419 15L7.5 8.80419L13.6958 15L15 13.6958L8.80419 7.5L15 1.30419Z"
        fill={props.fill || '#212C3A'}
      />
    </g>
  </svg>
);

export const PlainPlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 15}
    height={props.height ?? 15}
    fill="none"
  >
    <path
      fill="#212C3A"
      d="M13.13 6.099H7.964V.932A.945.945 0 0 0 7.03 0 .945.945 0 0 0 6.1.932V6.1H.932A.945.945 0 0 0 0 7.03c0 .505.427.933.932.933H6.1v5.166c0 .505.427.932.932.932a.945.945 0 0 0 .933-.932V7.964h5.166a.945.945 0 0 0 .932-.933.945.945 0 0 0-.932-.932Z"
    />
    <path
      fill="#000"
      fillOpacity=".2"
      d="M13.13 6.099H7.964V.932A.945.945 0 0 0 7.03 0 .945.945 0 0 0 6.1.932V6.1H.932A.945.945 0 0 0 0 7.03c0 .505.427.933.932.933H6.1v5.166c0 .505.427.932.932.932a.945.945 0 0 0 .933-.932V7.964h5.166a.945.945 0 0 0 .932-.933.945.945 0 0 0-.932-.932Z"
    />
    <path
      fill="#000"
      fillOpacity=".2"
      d="M13.13 6.099H7.964V.932A.945.945 0 0 0 7.03 0 .945.945 0 0 0 6.1.932V6.1H.932A.945.945 0 0 0 0 7.03c0 .505.427.933.932.933H6.1v5.166c0 .505.427.932.932.932a.945.945 0 0 0 .933-.932V7.964h5.166a.945.945 0 0 0 .932-.933.945.945 0 0 0-.932-.932Z"
    />
    <path
      fill="#000"
      fillOpacity=".2"
      d="M13.13 6.099H7.964V.932A.945.945 0 0 0 7.03 0 .945.945 0 0 0 6.1.932V6.1H.932A.945.945 0 0 0 0 7.03c0 .505.427.933.932.933H6.1v5.166c0 .505.427.932.932.932a.945.945 0 0 0 .933-.932V7.964h5.166a.945.945 0 0 0 .932-.933.945.945 0 0 0-.932-.932Z"
    />
  </svg>
);

export const PlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width ?? 20}
    height={props.height ?? 20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="plus-5">
      <circle
        id="Oval"
        cx={10}
        cy={10}
        r={10}
        fill="url(#paint0_linear_4781_2362)"
      />
      <path
        id="Shape"
        d="M14.4971 9.46025H10.3595V5.50258C10.3595 5.30362 10.1983 5.14279 9.99972 5.14279C9.80112 5.14279 9.63993 5.30362 9.63993 5.50258V9.46025H5.50237C5.30376 9.46025 5.14258 9.62108 5.14258 9.82004C5.14258 10.019 5.30376 10.1798 5.50237 10.1798H9.63993V14.4973C9.63993 14.6963 9.80112 14.8571 9.99972 14.8571C10.1983 14.8571 10.3595 14.6963 10.3595 14.4973V10.1798H14.4971C14.6957 10.1798 14.8569 10.019 14.8569 9.82004C14.8569 9.62108 14.6957 9.46025 14.4971 9.46025Z"
        fill="white"
        stroke="white"
        strokeWidth={1.17143}
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4781_2362"
        x1={-10}
        y1={10}
        x2={10}
        y2={30}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fe5722" />
        <stop offset={0.52908} stopColor="#fe5631" />
        <stop offset={0.832941} stopColor="#fe5449" />
        <stop offset={1} stopColor="#fe6168" />
      </linearGradient>
    </defs>
  </svg>
);

export const SearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width ?? 15}
    height={props.height ?? 15}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Icons Search">
      <path
        id="Shape"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3359 9.28631L13.7871 12.7518C14.0791 13.045 14.0694 13.5124 13.766 13.7943C13.6232 13.927 13.4351 14 13.2368 14C13.0273 14 12.8318 13.9196 12.6864 13.7739L9.20899 10.2821C8.22158 10.9521 7.06667 11.305 5.85474 11.305C2.62649 11.305 0 8.76923 0 5.65249C0 2.53576 2.62649 0 5.85474 0C9.08299 0 11.7095 2.53576 11.7095 5.65249C11.7095 6.98648 11.2233 8.26788 10.3359 9.28631ZM10.1821 5.65249C10.1821 3.34873 8.24092 1.47456 5.85474 1.47456C3.46855 1.47456 1.52732 3.34873 1.52732 5.65249C1.52732 7.95625 3.46855 9.83042 5.85474 9.83042C8.24092 9.83042 10.1821 7.95625 10.1821 5.65249Z"
        fill={props.fill ?? '#b1b8c6'}
      />
    </g>
  </svg>
);

export const FiltersIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width ?? 19}
    height={props.height ?? 20}
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill={props.fill ?? '#4c88f9'}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.078 1.506v4.026a2.57 2.57 0 0 1 2.065 2.515c0 1.245-.89 2.283-2.065 2.519v7.928a.504.504 0 0 1-.507.506.504.504 0 0 1-.506-.506V10.57A2.575 2.575 0 0 1 1 8.05c0-1.244.89-2.282 2.065-2.518V1.506c0-.281.225-.506.506-.506.282 0 .507.225.507.506ZM2.014 8.051a1.558 1.558 0 0 0 3.115 0 1.558 1.558 0 0 0-3.115 0Zm8.064-6.545v8.27a2.574 2.574 0 0 1 2.065 2.518c0 1.245-.89 2.283-2.065 2.519v3.681a.504.504 0 0 1-.507.506.504.504 0 0 1-.506-.506v-3.681A2.575 2.575 0 0 1 7 12.294c0-1.244.89-2.283 2.065-2.519V1.506c0-.281.225-.506.506-.506.282 0 .507.225.507.506ZM8.014 12.294a1.558 1.558 0 0 0 3.115 0 1.558 1.558 0 0 0-3.115 0Zm8.064-6.763V1.506A.504.504 0 0 0 15.571 1a.504.504 0 0 0-.506.506V5.53A2.574 2.574 0 0 0 13 8.049c0 1.245.89 2.283 2.065 2.519v7.926c0 .281.225.506.506.506a.504.504 0 0 0 .507-.506v-7.93a2.574 2.574 0 0 0 2.065-2.518 2.566 2.566 0 0 0-2.065-2.515Zm-.507 4.074c-.86 0-1.557-.697-1.557-1.556a1.557 1.557 0 0 1 3.115 0c0 .859-.698 1.556-1.558 1.556Z"
      />
      <path d="M4.078 5.532h-.25v.205l.201.04.05-.245Zm0 5.034-.05-.245-.2.04v.205h.25Zm-1.013.004h.25v-.205l-.201-.04-.05.245Zm0-5.038.049.245.2-.04v-.205h-.25Zm7.013 4.243h-.25v.205l.201.04.05-.245Zm0 5.038-.05-.245-.2.04v.205h.25Zm-1.013 0h.25v-.205l-.201-.04-.05.245Zm0-5.038.049.245.2-.04v-.205h-.25Zm7.013-4.244h-.25v.205l.201.04.05-.245Zm-1.013 0 .049.245.2-.04V5.53h-.25Zm0 5.037h.25v-.205l-.201-.04-.05.245Zm1.013-.004-.049-.245-.2.04v.205h.25ZM4.328 5.532V1.506h-.5v4.026h.5Zm2.065 2.515a2.82 2.82 0 0 0-2.266-2.76l-.098.49a2.32 2.32 0 0 1 1.864 2.27h.5Zm-2.266 2.764a2.824 2.824 0 0 0 2.266-2.764h-.5c0 1.123-.803 2.06-1.864 2.274l.098.49Zm.201 7.683v-7.928h-.5v7.928h.5Zm-.757.756c.42 0 .757-.337.757-.756h-.5a.254.254 0 0 1-.257.256v.5Zm-.756-.756c0 .42.337.756.756.756v-.5a.254.254 0 0 1-.256-.256h-.5Zm0-7.924v7.924h.5V10.57h-.5ZM.75 8.05c0 1.367.977 2.506 2.265 2.765l.099-.49A2.325 2.325 0 0 1 1.25 8.05h-.5Zm2.265-2.763A2.824 2.824 0 0 0 .75 8.05h.5c0-1.123.803-2.06 1.864-2.274l-.099-.49Zm-.2-3.781v4.026h.5V1.506h-.5ZM3.57.75a.754.754 0 0 0-.756.756h.5c0-.143.113-.256.256-.256v-.5Zm.757.756A.754.754 0 0 0 3.571.75v.5c.144 0 .257.113.257.256h.5Zm-.757 7.85a1.308 1.308 0 0 1-1.307-1.305h-.5c0 .997.81 1.805 1.807 1.805v-.5Zm1.31-1.305a1.31 1.31 0 0 1-1.308 1.305v.5A1.81 1.81 0 0 0 5.38 8.051h-.5ZM3.571 6.745c.722 0 1.308.586 1.308 1.306h.5c0-.997-.81-1.806-1.808-1.806v.5ZM2.264 8.051c0-.72.586-1.306 1.307-1.306v-.5c-.997 0-1.807.809-1.807 1.806h.5Zm8.064 1.724V1.506h-.5v8.27h.5Zm2.065 2.519a2.824 2.824 0 0 0-2.266-2.764l-.098.49a2.324 2.324 0 0 1 1.864 2.274h.5Zm-2.266 2.764a2.825 2.825 0 0 0 2.266-2.764h-.5c0 1.122-.803 2.06-1.864 2.274l.098.49Zm.201 3.436v-3.681h-.5v3.681h.5Zm-.757.756c.42 0 .757-.337.757-.756h-.5a.254.254 0 0 1-.257.256v.5Zm-.756-.756c0 .42.337.756.756.756v-.5a.254.254 0 0 1-.256-.256h-.5Zm0-3.681v3.681h.5v-3.681h-.5ZM6.75 12.294c0 1.367.977 2.505 2.265 2.764l.099-.49a2.324 2.324 0 0 1-1.864-2.274h-.5ZM9.015 9.53a2.824 2.824 0 0 0-2.265 2.764h.5c0-1.122.803-2.06 1.864-2.274l-.099-.49Zm-.2-8.024v8.27h.5v-8.27h-.5ZM9.57.75a.754.754 0 0 0-.756.756h.5c0-.143.113-.256.256-.256v-.5Zm.757.756A.754.754 0 0 0 9.571.75v.5c.144 0 .257.113.257.256h.5ZM9.571 13.6a1.308 1.308 0 0 1-1.307-1.306h-.5c0 .997.81 1.806 1.807 1.806v-.5Zm1.308-1.306c0 .72-.586 1.306-1.308 1.306v.5c.998 0 1.808-.81 1.808-1.806h-.5Zm-1.308-1.306c.722 0 1.308.586 1.308 1.306h.5c0-.997-.81-1.806-1.808-1.806v.5Zm-1.307 1.306c0-.72.586-1.306 1.307-1.306v-.5c-.997 0-1.807.81-1.807 1.806h.5Zm7.564-10.788V5.53h.5V1.506h-.5Zm-.257-.256c.144 0 .257.113.257.256h.5a.754.754 0 0 0-.757-.756v.5Zm-.256.256c0-.143.113-.256.256-.256v-.5a.754.754 0 0 0-.756.756h.5Zm0 4.025V1.506h-.5V5.53h.5ZM13.25 8.049c0-1.122.803-2.06 1.864-2.273l-.099-.49a2.824 2.824 0 0 0-2.265 2.763h.5Zm1.864 2.274a2.324 2.324 0 0 1-1.864-2.274h-.5c0 1.367.977 2.505 2.265 2.764l.099-.49Zm.2 8.171v-7.926h-.5v7.926h.5Zm.257.256a.254.254 0 0 1-.256-.256h-.5c0 .42.337.756.756.756v-.5Zm.257-.256a.254.254 0 0 1-.257.256v.5c.42 0 .757-.336.757-.756h-.5Zm0-7.93v7.93h.5v-7.93h-.5Zm2.065-2.518c0 1.122-.803 2.06-1.864 2.273l.099.49a2.824 2.824 0 0 0 2.265-2.763h-.5Zm-1.864-2.27a2.316 2.316 0 0 1 1.864 2.27h.5a2.816 2.816 0 0 0-2.266-2.76l-.098.49Zm-2.265 2.273c0 .997.81 1.806 1.807 1.806v-.5a1.308 1.308 0 0 1-1.307-1.306h-.5Zm1.807-1.805c-.997 0-1.807.809-1.807 1.805h.5c0-.72.586-1.305 1.307-1.305v-.5ZM17.38 8.05c0-.996-.81-1.805-1.808-1.805v.5c.722 0 1.308.586 1.308 1.305h.5Zm-1.808 1.806c.998 0 1.808-.809 1.808-1.806h-.5c0 .72-.586 1.306-1.308 1.306v.5Z" />
    </g>
  </svg>
);

export const AngleBackIcon = ({
  isRotated,
  rotateAngle,
  ...props
}: SVGProps<SVGSVGElement> & { isRotated?: boolean; rotateAngle?: number }) => (
  <svg
    data-testid="angle-back-icon"
    {...props}
    width={props.width ?? 10}
    height={props.height ?? 18}
    viewBox="0 0 10 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      transform: isRotated
        ? 'rotate(180deg)'
        : rotateAngle
        ? `rotate(${rotateAngle}deg)`
        : undefined,
    }}
  >
    <g id="Back">
      <path
        id="Path 3"
        d="M10 1.95L8.54272 0.5L0 9L8.54272 17.5L10 16.05L2.91457 9L10 1.95Z"
        fill={props.fill ?? '#212C3A'}
      />
    </g>
  </svg>
);

export const HeartIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={18}
    viewBox="0 0 20 18"
    fill={props.fill ?? 'none'}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.942 16.427c-.385.28-.707.506-.94.667a47.013 47.013 0 0 1-4.006-3.097c-1.137-.986-2.287-2.097-3.207-3.228-.93-1.144-1.57-2.245-1.776-3.21l-.008-.034-.01-.034A5.295 5.295 0 0 1 .75 5.898c0-1.955 1.036-3.642 2.545-4.515A4.707 4.707 0 0 1 5.648.75c1.505 0 2.86.714 3.767 1.852l.588.738.586-.739C11.491 1.464 12.846.75 14.35.75c.853 0 1.654.23 2.355.633 1.51.874 2.546 2.561 2.546 4.515 0 .556-.088 1.092-.245 1.593l-.011.034-.008.035c-.206.964-.847 2.065-1.776 3.209-.92 1.13-2.069 2.242-3.205 3.228a46.97 46.97 0 0 1-3.063 2.43Z"
      stroke={props.stroke ?? '#fff'}
      strokeWidth={1.5}
    />
  </svg>
);

export const HeartIconInactive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={18}
    fill={props.fill ?? 'none'}
    viewBox="0 0 20 18"
    {...props}
  >
    <path
      fill="#212c3a"
      fillOpacity=".3"
      stroke="#f9f9f9"
      strokeWidth="1.5"
      d="M14.35.75c.852 0 1.652.23 2.353.632 1.51.875 2.547 2.562 2.547 4.515 0 .557-.087 1.093-.245 1.594l-.01.033-.009.036c-.206.964-.847 2.065-1.776 3.209-.92 1.13-2.07 2.242-3.205 3.228A47 47 0 0 1 10 17.094a47.015 47.015 0 0 1-4.006-3.097C4.858 13.012 3.708 11.9 2.79 10.77c-.93-1.144-1.57-2.245-1.776-3.21l-.008-.035-.01-.033L.89 7.11a5.3 5.3 0 0 1-.14-1.212c0-1.954 1.036-3.642 2.546-4.514l-.001-.001A4.7 4.7 0 0 1 5.648.75c1.506 0 2.86.714 3.767 1.853l.588.738.587-.74C11.492 1.465 12.847.75 14.35.75Z"
    />
  </svg>
);

export const HeartActiveIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={18}
    fill="none"
  >
    <path
      fill="#ff4f08"
      stroke={props.stroke ?? '#fff'}
      strokeWidth={1.5}
      d="M10.942 16.427c-.385.28-.707.506-.94.667a47.013 47.013 0 0 1-4.006-3.097c-1.137-.986-2.287-2.097-3.207-3.228-.93-1.144-1.57-2.245-1.776-3.21l-.008-.034-.01-.034A5.295 5.295 0 0 1 .75 5.898c0-1.955 1.036-3.642 2.545-4.515A4.707 4.707 0 0 1 5.648.75c1.505 0 2.86.714 3.767 1.852l.588.738.586-.739C11.491 1.464 12.846.75 14.35.75c.853 0 1.654.23 2.355.633 1.51.874 2.546 2.561 2.546 4.515 0 .556-.088 1.092-.245 1.593l-.011.034-.008.035c-.206.964-.847 2.065-1.776 3.209-.92 1.13-2.069 2.242-3.205 3.228a46.97 46.97 0 0 1-3.063 2.43Z"
    />
  </svg>
);

export const CheckboxSelectedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="selected checkbox">
      <rect id="Rectangle 41" width={20} height={20} rx={5} fill="#FF4F08" />
      <path
        id="Vector 2"
        d="M6 10L9 13L15 7"
        stroke="white"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const RemoveRoundIcon = ({
  isFullOpacity,
  ...props
}: SVGProps<SVGSVGElement> & { isFullOpacity?: boolean }) => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#a)">
      <circle
        cx={12.5}
        cy={12.5}
        r={12.5}
        fill="#fff"
        fillOpacity={isFullOpacity ? 1 : 0.5}
      />
    </g>
    <path
      d="M17 8.782 16.218 8 12.5 11.717 8.783 8 8 8.782l3.717 3.718L8 16.217l.783.783 3.717-3.717L16.218 17l.782-.783-3.717-3.717L17 8.782Z"
      fill="#ff4f08"
      stroke="#ff4f08"
      strokeWidth={0.5}
    />
    <defs>
      <filter
        id="a"
        x={-24.27}
        y={-24.27}
        width={73.541}
        height={73.541}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={12.135} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_5679_9851"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_5679_9851"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const RotateRoundIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    {...props}
  >
    <g filter="url(#a)">
      <circle cx={12.5} cy={12.5} r={12.5} fill="#fff" fillOpacity={0.5} />
    </g>
    <path
      d="M6.715 7.727a7.533 7.533 0 0 0-1.7 4.762c0 4.142 3.36 7.511 7.492 7.511S20 16.63 20 12.49a7.466 7.466 0 0 0-2.249-5.366.86.86 0 0 0-1.218.013.865.865 0 0 0 .012 1.22 5.748 5.748 0 0 1 1.732 4.132c0 3.19-2.588 5.784-5.77 5.784-3.182 0-5.76-2.594-5.76-5.784 0-1.252.397-2.456 1.143-3.44v.692a.862.862 0 1 0 1.722 0V6.864A.879.879 0 0 0 8.732 6h-2.87a.862.862 0 0 0 0 1.727h.853Z"
      fill="#ff4f08"
    />
    <defs>
      <filter
        id="a"
        x={-24.27}
        y={-24.27}
        width={73.541}
        height={73.541}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={12.135} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_5679_9854"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_5679_9854"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const ShareIcon = ({
  stroke,
  ...props
}: SVGProps<SVGSVGElement> & { stroke?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M17.5 10V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V10M13.3333 5.83333L10 2.5M10 2.5L6.66667 5.83333M10 2.5V12.5"
      stroke={stroke ?? '#212C3A'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PhoneIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 18}
    height={props.height ?? 18}
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M17.742 13.916a.823.823 0 0 1-.252.72l-2.394 2.378c-.108.12-.248.222-.422.306a1.747 1.747 0 0 1-.513.162l-.108.009c-.06.006-.138.009-.234.009-.228 0-.597-.039-1.107-.117-.51-.078-1.134-.27-1.872-.576-.738-.306-1.575-.766-2.51-1.378-.936-.612-1.932-1.453-2.988-2.521-.84-.829-1.536-1.62-2.087-2.377a16.934 16.934 0 0 1-1.332-2.098 11.303 11.303 0 0 1-.756-1.747 9.273 9.273 0 0 1-.342-1.35 4.463 4.463 0 0 1-.072-.892c.012-.216.018-.336.018-.36.024-.168.078-.34.162-.514a1.35 1.35 0 0 1 .306-.423L3.632.752A.792.792 0 0 1 4.208.5c.156 0 .294.045.414.135.12.09.222.201.306.333l1.926 3.656a.877.877 0 0 1 .09.63c-.048.228-.15.42-.306.577l-.882.882a.3.3 0 0 0-.063.117.445.445 0 0 0-.027.135c.048.252.156.54.324.864.144.289.366.64.666 1.054.3.414.726.891 1.278 1.432.54.552 1.02.981 1.44 1.287.42.306.77.531 1.052.675.282.145.498.232.648.262l.225.045a.427.427 0 0 0 .117-.027.299.299 0 0 0 .117-.064l1.026-1.044c.216-.192.468-.288.756-.288.204 0 .366.036.486.108h.018l3.473 2.053c.252.156.402.354.45.594Z"
      fill={props.fill ?? '#fff'}
    />
  </svg>
);

export const ChatIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={18}
    viewBox="0 0 19 18"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.25 9a9 9 0 0 1-13.672 7.694l-3.962.987.979-3.946A9 9 0 1 1 18.25 9ZM5.2 10.35a1.35 1.35 0 1 0 0-2.7 1.35 1.35 0 0 0 0 2.7ZM10.6 9a1.35 1.35 0 1 1-2.7 0 1.35 1.35 0 0 1 2.7 0Zm2.7 1.35a1.35 1.35 0 1 0 0-2.7 1.35 1.35 0 0 0 0 2.7Z"
      fill="#fff"
    />
  </svg>
);

export const QuestionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      d="M5.032 5.628c.005-.288.055-.552.148-.792s.224-.448.392-.624.37-.313.608-.412a2.05 2.05 0 0 1 .796-.148c.379 0 .695.052.948.156.253.104.457.233.612.388a1.436 1.436 0 0 1 .432 1c0 .256-.033.467-.1.632a1.558 1.558 0 0 1-.576.724c-.12.083-.233.165-.34.248a1.59 1.59 0 0 0-.284.284.816.816 0 0 0-.156.4v.304h-1.08v-.36c.016-.23.06-.421.132-.576a1.64 1.64 0 0 1 .252-.396c.096-.11.197-.204.304-.284a4.8 4.8 0 0 0 .296-.24c.09-.08.164-.168.22-.264a.655.655 0 0 0 .076-.36c0-.245-.06-.427-.18-.544-.12-.117-.287-.176-.5-.176a.774.774 0 0 0-.372.084.742.742 0 0 0-.256.224.972.972 0 0 0-.148.328c-.032.125-.048.26-.048.404H5.032Zm2.544 2.64V9.5H6.32V8.268h1.256Z"
      fill="#ff4f08"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0ZM1 7a6 6 0 1 1 12 0A6 6 0 0 1 1 7Z"
      fill="#ff4f08"
    />
  </svg>
);

export const ContactsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={55}
    height={50}
    viewBox="0 0 55 50"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.709 0H50.4c2.61 0 4.708 2.127 4.595 4.772v12.131c0 2.645-2.099 4.772-4.709 4.772H38.374l-5.333 5.405a3.08 3.08 0 0 1-2.155.92 2.93 2.93 0 0 1-1.192-.23c-1.191-.46-1.929-1.61-1.929-2.875v-3.22h-.056c-2.61 0-4.709-2.126-4.709-4.771V4.773C23 2.128 25.099 0 27.709 0ZM50.4 18.63a1.72 1.72 0 0 0 1.702-1.725h-.057V4.773c0-.92-.738-1.725-1.702-1.725H27.709c-.908 0-1.702.747-1.702 1.724v12.132c0 .92.737 1.725 1.702 1.725h1.588c.851 0 1.532.69 1.532 1.552v4.715s0 .057.057.057c0 .057.056 0 .056 0l5.787-5.864a1.54 1.54 0 0 1 1.078-.46H50.4ZM31.133 33.498l5.713 4.51c1.714 1.37 2.514 3.655 2 5.711a7.841 7.841 0 0 1-2.114 3.883C35.19 49.2 32.962 50 30.391 50c-5.714 0-13.312-4.054-19.825-10.564-4.343-4.282-7.599-9.193-9.313-13.704-2.685-7.138-.457-10.849 1.142-12.448 1.086-1.085 2.457-1.827 4.114-2.17A6.31 6.31 0 0 1 7.595 11c1.714 0 3.37.8 4.456 2.17l4.513 5.71c.629.856 1.086 1.827 1.257 2.855a5.602 5.602 0 0 1-1.828 5.025.784.784 0 0 0-.057 1.028 41.622 41.622 0 0 0 6.341 6.338c.286.285.743.228 1.028-.057 1.143-1.313 2.8-1.999 4.571-1.885 1.2.114 2.343.571 3.257 1.314Zm3.428 12.048c.685-.685 1.086-1.485 1.314-2.456.228-1.028-.115-2.056-.8-2.627l-5.828-4.568a2.651 2.651 0 0 0-1.657-.57c-.913 0-1.77.456-2.285 1.255l-.685 1.085a1.515 1.515 0 0 1-2.171.457A44.891 44.891 0 0 1 12.05 27.73c-.514-.686-.286-1.713.457-2.17l1.085-.685c1.371-.8 1.657-2.627.686-3.883l-4.57-5.824C9.193 14.54 8.45 14.14 7.65 14.14c-.17 0-.342 0-.514.057a4.642 4.642 0 0 0-2.57 1.313c-3.828 3.769-.172 13.59 8.17 21.87 6.056 6.053 12.911 9.65 17.654 9.65 1.714 0 3.142-.457 4.17-1.484ZM29 10.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0Zm9.5 2.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm4.5-2.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0Z"
      fill="#ff4f08"
    />
  </svg>
);

export const FlagIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={20}
    viewBox="0 0 17 20"
    fill="none"
    {...props}
  >
    <path
      d="M12.526 1.887C9.842 1.887 7.158.16 4.474.16 1.789.16 0 1.024 0 1.024v17.272c0 .23.094.449.262.611a.912.912 0 0 0 .633.253.912.912 0 0 0 .632-.253.849.849 0 0 0 .262-.61v-5.754c.88-.194 1.781-.293 2.685-.292 2.684 0 5.368 1.727 8.052 1.727 2.684 0 4.474-.864 4.474-.864V1.024s-1.79.863-4.474.863Zm2.684 10.017a10.42 10.42 0 0 1-2.684.347c-1.308 0-2.585-.496-3.808-.887-1.374-.439-2.784-.84-4.244-.84-.901 0-1.8.084-2.685.253V2.234c.872-.233 1.78-.347 2.685-.347 1.308 0 2.585.496 3.808.887 1.374.439 2.784.84 4.244.84.902 0 1.8-.084 2.684-.253v8.543Z"
      fill={props.fill ?? '#212c3a'}
    />
  </svg>
);

export const FlagFilledIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={20}
    viewBox="0 0 17 20"
    fill="none"
    {...props}
  >
    <path
      d="M4.474.16c2.684 0 5.368 1.727 8.052 1.727 2.684 0 4.474-.863 4.474-.863v12.09s-1.79.864-4.474.864-5.368-1.727-8.052-1.727c-.904 0-1.804.098-2.685.292v5.753a.849.849 0 0 1-.262.611.912.912 0 0 1-.632.253.912.912 0 0 1-.633-.253.849.849 0 0 1-.262-.61V1.023S1.79.16 4.474.16Z"
      fill={props.fill ?? '#212c3a'}
    />
  </svg>
);

export const LocationIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={16}
    viewBox="0 0 11 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 3.692a1.84 1.84 0 0 0-1.833 1.846c0 1.02.82 1.847 1.833 1.847a1.84 1.84 0 0 0 1.833-1.847A1.84 1.84 0 0 0 5.5 3.692ZM5.5 16S11 8.597 11 5.538C11 2.48 8.538 0 5.5 0S0 2.48 0 5.538C0 8.598 5.5 16 5.5 16Z"
      fill={props.fill ?? '#8d94ad'}
    />
  </svg>
);

export const LocationOutlinedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    {...props}
  >
    <path
      stroke="#212c3a"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth=".667"
      d="M8.503 9.208a2.125 2.125 0 1 0 0-4.25 2.125 2.125 0 0 0 0 4.25"
    />
    <path
      stroke="#212c3a"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth=".667"
      d="M8.503 15.583c2.833-2.834 5.666-5.37 5.666-8.5a5.667 5.667 0 0 0-11.333 0c0 3.13 2.833 5.666 5.667 8.5"
    />
  </svg>
);

export const CategoriesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M17.438 10.125h-6.75a.562.562 0 0 0-.563.563v6.75c0 .31.252.562.563.562h6.75a.562.562 0 0 0 .562-.563v-6.75a.562.562 0 0 0-.563-.562Zm0-10.125h-6.75a.562.562 0 0 0-.563.562v6.75c0 .312.252.563.563.563h6.75A.562.562 0 0 0 18 7.312V.563A.562.562 0 0 0 17.437 0ZM7.312 0H.562A.563.563 0 0 0 0 .562v6.75c0 .312.252.563.562.563h6.75a.562.562 0 0 0 .563-.563V.563A.563.563 0 0 0 7.312 0Zm0 10.125H.562a.562.562 0 0 0-.562.563v6.75c0 .31.252.562.562.562h6.75a.562.562 0 0 0 .563-.563v-6.75a.562.562 0 0 0-.563-.562Z"
      fill={props.fill || '#ff4f08'}
    />
  </svg>
);

export const SortingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={16}
    viewBox="0 0 19 16"
    fill="none"
    {...props}
  >
    <path
      d="M14.872.822C14.668.626 14.42.504 14.155.5a.902.902 0 0 0-.7.334L9.496 5.012l-.001.002a.89.89 0 0 0 .093 1.277l.009.007c.278.21.57.25.817.2a.872.872 0 0 0 .516-.307l2.252-2.416v10.816c0 .502.432.909.951.909.503 0 .952-.356.952-.876V3.779l2.261 2.427.01.01c.36.342.93.407 1.323.079l.011-.011c.36-.347.43-.894.081-1.271L14.882.831l-.01-.009ZM4.865.5c-.519 0-.951.406-.951.909v10.836L1.653 9.82l-.01-.01c-.36-.342-.93-.406-1.322-.078l-.01.01c-.362.343-.431.89-.084 1.266l3.923 4.175a.927.927 0 0 0 1.398-.002l3.954-4.17v-.002a.886.886 0 0 0-.092-1.277c-.386-.323-.998-.272-1.332.09l-2.26 2.423V1.409C5.817.906 5.384.5 4.864.5Z"
      fill="#ff4f08"
    />
  </svg>
);

export const ShieldIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    data-testid="shield-icon"
    xmlns="http://www.w3.org/2000/svg"
    width={55}
    height={68}
    viewBox="0 0 55 68"
    fill="none"
    {...props}
  >
    <path
      opacity={0.15}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 15.007v16.48c0 7.345 2.134 14.53 6.141 20.67a37.552 37.552 0 0 0 16.415 13.899L26.997 68l4.959-2.106a37.456 37.456 0 0 0 16.77-13.876A37.751 37.751 0 0 0 55 31.115V14.972L27.137 0 0 15.007Zm49.5 3.4v12.81a32.123 32.123 0 0 1-5.358 17.818 31.996 31.996 0 0 1-14.328 11.832l-2.805 1.16-2.265-.984a32.072 32.072 0 0 1-14.01-11.858A32.194 32.194 0 0 1 5.5 31.57V18.385L27.178 6.433 49.5 18.407ZM39.253 23l3.86 4.058L24.437 45 13.034 33.533l3.952-3.974 7.54 7.584L39.254 23Z"
      fill="#b1b8c6"
    />
  </svg>
);

export const AttachIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={26}
    viewBox="0 0 25 26"
    fill="none"
    {...props}
  >
    <path
      d="M8.037 25.5c-4.003.015-7.604-3.287-7.995-7.622-.245-2.693.582-5.016 2.451-6.932a1045.45 1045.45 0 0 1 8.516-8.617C12.706.634 14.769.1 17.049.797c2.28.697 3.684 2.295 4.167 4.65.418 2.04-.086 3.902-1.523 5.394a638.08 638.08 0 0 1-8.672 8.795c-1.02 1.018-2.294 1.288-3.66.873-1.332-.406-2.173-1.332-2.468-2.715-.267-1.258.03-2.399.918-3.31 2.266-2.334 4.56-4.64 6.85-6.948.518-.524 1.292-.51 1.785-.005.494.505.488 1.288-.047 1.832a3543.54 3543.54 0 0 1-6.669 6.755c-.311.315-.479.675-.392 1.121.087.446.346.746.778.88.452.139.853.029 1.184-.302.669-.666 1.329-1.337 1.991-2.011 2.113-2.143 4.226-4.284 6.34-6.423.623-.63 1.02-1.364 1.116-2.257a3.604 3.604 0 0 0-1.978-3.638 3.516 3.516 0 0 0-4.045.68c-1.366 1.372-2.721 2.754-4.085 4.131-1.463 1.483-2.934 2.958-4.388 4.45-2.302 2.361-2.344 6.036-.11 8.429 2.037 2.181 5.673 2.425 8.063.474.87-.71 1.63-1.561 2.424-2.363 2.73-2.758 5.458-5.52 8.182-8.285.436-.44.963-.55 1.47-.31.465.218.75.704.717 1.222-.023.39-.223.68-.487.948-2.887 2.921-5.773 5.843-8.657 8.766-.642.649-1.272 1.318-1.973 1.898-1.606 1.332-3.479 1.952-5.843 1.972Z"
      fill="#ff4f08"
    />
  </svg>
);

export const ArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={17}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M.515 7.736 2.44 9.648 6.642 5.5v10.985h2.716V5.5l4.202 4.148 1.925-1.912L8 .364.515 7.736Z"
      fill="#fff"
    />
  </svg>
);

export const MoreHorizontalIcon = (props: SVGProps<SVGSVGElement>) => {
  const fill = props?.fill ?? '#8d94ad';

  return (
    <svg
      width={21}
      height={6}
      viewBox="0 0 21 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={2.5} cy={3} r={2.5} fill={fill} />
      <circle cx={10.5} cy={3} r={2.5} fill={fill} />
      <circle cx={18.5} cy={3} r={2.5} fill={fill} />
    </svg>
  );
};

export const ReadMessageIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={8}
    viewBox="0 0 15 8"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.65 7.391c.076.07.178.11.283.109a.412.412 0 0 0 .283-.109l1.718-1.605 1.717 1.605a.41.41 0 0 0 .282.109.412.412 0 0 0 .283-.109l6.661-6.22a.383.383 0 0 0 .008-.552.413.413 0 0 0-.573-.009L7.933 6.567l-1.431-1.31 4.375-4.087a.382.382 0 0 0 .008-.552.413.413 0 0 0-.573-.008L3.933 6.567 1.188 4A.407.407 0 0 0 .9 3.89a.419.419 0 0 0-.285.118.39.39 0 0 0-.115.277.378.378 0 0 0 .123.275L3.65 7.39Z"
      fill="#fff"
    />
  </svg>
);

export const ErrorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    data-testid="error-icon"
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <circle cx={10} cy={10} r={10} fill="#ff586d" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.08 4h-2v3.296l.528 4.944h.944l.528-4.944V4Zm.064 9.424H9v2h2.144v-2Z"
      fill="#fff"
    />
  </svg>
);

export const CalendarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={15}
    height={17}
    viewBox="0 0 15 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.359 7.04H.649a.585.585 0 0 1-.578-.592c0-.328.259-.593.577-.593h13.71c.32 0 .578.265.578.593a.585.585 0 0 1-.577.593Zm-3.435 3.089a.588.588 0 0 1-.58-.593c0-.328.255-.594.573-.594h.007c.319 0 .577.266.577.594a.585.585 0 0 1-.577.593Zm-3.414 0a.588.588 0 0 1-.58-.593c0-.328.255-.594.574-.594h.007c.318 0 .577.266.577.594a.585.585 0 0 1-.577.593Zm-3.42 0a.589.589 0 0 1-.58-.593c0-.328.255-.594.573-.594h.007c.318 0 .577.266.577.594a.585.585 0 0 1-.577.593Zm6.834 3.073a.588.588 0 0 1-.58-.593c0-.328.255-.593.573-.593h.007c.319 0 .577.265.577.593a.585.585 0 0 1-.577.593Zm-3.414 0a.588.588 0 0 1-.58-.593c0-.328.255-.593.574-.593h.007c.318 0 .577.265.577.593a.585.585 0 0 1-.577.593Zm-3.42 0a.589.589 0 0 1-.58-.593c0-.328.255-.593.573-.593h.007c.318 0 .577.265.577.593a.585.585 0 0 1-.577.593Zm6.52-9.414a.585.585 0 0 1-.577-.593V.593c0-.327.259-.593.577-.593.319 0 .577.266.577.593v2.602a.585.585 0 0 1-.577.593Zm-6.214 0a.585.585 0 0 1-.577-.593V.593c0-.327.259-.593.577-.593.319 0 .577.266.577.593v2.602a.585.585 0 0 1-.577.593Z"
      fill="#212c3a"
    />
    <mask
      id="a"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={1}
      width={15}
      height={16}
    >
      <path d="M0 1.249h15V17H0V1.249Z" fill="#fff" />
    </mask>
    <g mask="url(#a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.247 2.435c-1.995 0-3.093 1.093-3.093 3.079v7.155c0 2.029 1.098 3.145 3.093 3.145h6.506c1.995 0 3.093-1.096 3.093-3.085V5.514c.003-.977-.252-1.736-.76-2.258-.52-.537-1.325-.821-2.326-.821H4.247ZM10.753 17H4.247C1.627 17 0 15.34 0 12.67V5.514c0-2.632 1.628-4.265 4.247-4.265h6.513c1.315 0 2.402.404 3.144 1.169.72.744 1.1 1.814 1.096 3.097v7.214C15 15.363 13.372 17 10.753 17Z"
        fill="#212c3a"
      />
    </g>
  </svg>
);

export const EditIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)" fill="#212c3a" stroke="#212c3a" strokeWidth={0.5}>
      <path d="M17.459 12.404a.448.448 0 0 0-.447.45v3.99c0 .744-.6 1.347-1.34 1.348H3.142c-.74 0-1.339-.604-1.34-1.348V5.132c.001-.744.6-1.347 1.34-1.348h3.965a.448.448 0 0 0 .447-.45c0-.247-.2-.449-.447-.449H3.142A2.243 2.243 0 0 0 .909 5.132v11.712c.001 1.24 1 2.245 2.233 2.247h12.53a2.242 2.242 0 0 0 2.233-2.247v-3.99c0-.249-.2-.45-.446-.45Z" />
      <path d="M17.95 1.513a2.062 2.062 0 0 0-2.915 0L6.86 9.686a.458.458 0 0 0-.117.201l-1.075 3.88a.458.458 0 0 0 .564.564l3.88-1.075a.458.458 0 0 0 .202-.117l8.173-8.173a2.064 2.064 0 0 0 0-2.916l-.538-.537ZM7.86 9.983l6.689-6.689 2.157 2.158-6.69 6.689L7.86 9.983Zm-.431.865 1.723 1.724-2.384.66.66-2.384Zm10.411-6.53-.486.486-2.157-2.158.486-.485a1.145 1.145 0 0 1 1.62 0l.537.537a1.147 1.147 0 0 1 0 1.62Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const SettingsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m18.573 8.662 1.403.239A1.22 1.22 0 0 1 21 10.12v1.758c0 .606-.435 1.12-1.032 1.22l-1.404.234A7.86 7.86 0 0 1 18 14.695l.827 1.162a1.237 1.237 0 0 1-.133 1.592l-1.245 1.245a1.226 1.226 0 0 1-.874.363c-.259 0-.51-.08-.718-.23L14.7 18c-.435.23-.89.418-1.362.564l-.239 1.404A1.234 1.234 0 0 1 11.88 21h-1.763c-.605 0-1.12-.435-1.22-1.032l-.234-1.404a7.902 7.902 0 0 1-1.32-.543l-1.174.836a1.226 1.226 0 0 1-1.588-.134l-1.245-1.245a1.232 1.232 0 0 1-.133-1.592l.823-1.145a7.732 7.732 0 0 1-.573-1.357l-1.42-.243A1.234 1.234 0 0 1 1 11.921v-1.759c0-.606.435-1.12 1.032-1.22l1.387-.234c.142-.472.326-.927.556-1.366l-.836-1.174a1.237 1.237 0 0 1 .134-1.592l1.249-1.245a1.22 1.22 0 0 1 .873-.363c.26 0 .51.08.719.23l1.149.827c.434-.234.89-.426 1.358-.573l.242-1.42c.1-.597.614-1.032 1.22-1.032h1.759c.606 0 1.12.435 1.22 1.032l.234 1.387c.489.146.96.343 1.412.58l1.161-.826a1.227 1.227 0 0 1 1.588.134l1.245 1.244c.43.426.485 1.1.134 1.592L18.009 7.3c.23.435.417.89.564 1.362Zm1.215 3.326a.108.108 0 0 0 .092-.109h.004v-1.758a.11.11 0 0 0-.092-.11l-1.754-.296a.555.555 0 0 1-.451-.413 6.689 6.689 0 0 0-.727-1.751.565.565 0 0 1 .025-.614l1.031-1.45a.113.113 0 0 0-.012-.142L16.659 4.1a.112.112 0 0 0-.08-.033.124.124 0 0 0-.062.02l-1.441 1.037a.565.565 0 0 1-.615.025 6.782 6.782 0 0 0-1.792-.736.565.565 0 0 1-.418-.455l-.292-1.742a.108.108 0 0 0-.109-.092h-1.759c-.054 0-.1.037-.108.092l-.301 1.767a.572.572 0 0 1-.414.451 6.625 6.625 0 0 0-1.746.736.572.572 0 0 1-.619-.025l-1.44-1.028a.103.103 0 0 0-.064-.021c-.02 0-.05.004-.079.033L4.075 5.374a.114.114 0 0 0-.013.142l1.04 1.463c.13.18.143.417.03.61a6.681 6.681 0 0 0-.714 1.754.565.565 0 0 1-.456.418l-1.742.293a.108.108 0 0 0-.092.108v1.76c0 .053.038.1.092.108l1.767.3a.573.573 0 0 1 .451.414c.16.614.41 1.204.736 1.747a.572.572 0 0 1-.025.618L4.12 16.55a.113.113 0 0 0 .012.142l1.245 1.245c.03.03.063.034.08.034.02 0 .042-.009.063-.021l1.462-1.04a.55.55 0 0 1 .326-.105.58.58 0 0 1 .284.075c.539.31 1.115.548 1.713.702a.56.56 0 0 1 .413.451l.293 1.755a.108.108 0 0 0 .108.092h1.76c.054 0 .1-.037.108-.092l.297-1.755a.554.554 0 0 1 .413-.45 6.69 6.69 0 0 0 1.75-.728.565.565 0 0 1 .615.025l1.45 1.032a.097.097 0 0 0 .062.021c.021 0 .05-.004.08-.033l1.245-1.245a.114.114 0 0 0 .012-.142l-1.032-1.454a.565.565 0 0 1-.025-.614 6.688 6.688 0 0 0 .727-1.75.56.56 0 0 1 .451-.415l1.755-.292Z"
      fill="#212c3a"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.686 10.998a4.319 4.319 0 0 1 4.316-4.316 4.319 4.319 0 0 1 4.316 4.316 4.319 4.319 0 0 1-4.316 4.316 4.319 4.319 0 0 1-4.316-4.316Zm1.128 0a3.19 3.19 0 0 0 3.188 3.188 3.19 3.19 0 0 0 3.188-3.188 3.19 3.19 0 0 0-3.188-3.188 3.19 3.19 0 0 0-3.188 3.188Z"
      fill="#212c3a"
    />
    <path
      clipRule="evenodd"
      d="m18.573 8.662 1.403.239A1.22 1.22 0 0 1 21 10.12v1.758c0 .606-.435 1.12-1.032 1.22l-1.404.234A7.86 7.86 0 0 1 18 14.695l.827 1.162a1.237 1.237 0 0 1-.133 1.592l-1.245 1.245a1.226 1.226 0 0 1-.874.363c-.259 0-.51-.08-.718-.23L14.7 18c-.435.23-.89.418-1.362.564l-.239 1.404A1.234 1.234 0 0 1 11.88 21h-1.763c-.605 0-1.12-.435-1.22-1.032l-.234-1.404a7.902 7.902 0 0 1-1.32-.543l-1.174.836a1.226 1.226 0 0 1-1.588-.134l-1.245-1.245a1.232 1.232 0 0 1-.133-1.592l.823-1.145a7.732 7.732 0 0 1-.573-1.357l-1.42-.243A1.234 1.234 0 0 1 1 11.921v-1.759c0-.606.435-1.12 1.032-1.22l1.387-.234c.142-.472.326-.927.556-1.366l-.836-1.174a1.237 1.237 0 0 1 .134-1.592l1.249-1.245a1.22 1.22 0 0 1 .873-.363c.26 0 .51.08.719.23l1.149.827c.434-.234.89-.426 1.358-.573l.242-1.42c.1-.597.614-1.032 1.22-1.032h1.759c.606 0 1.12.435 1.22 1.032l.234 1.387c.489.146.96.343 1.412.58l1.161-.826a1.227 1.227 0 0 1 1.588.134l1.245 1.244c.43.426.485 1.1.134 1.592L18.009 7.3c.23.435.417.89.564 1.362Zm1.215 3.326a.108.108 0 0 0 .092-.109h.004v-1.758a.11.11 0 0 0-.092-.11l-1.754-.296a.555.555 0 0 1-.451-.413 6.689 6.689 0 0 0-.727-1.751.565.565 0 0 1 .025-.614l1.031-1.45a.113.113 0 0 0-.012-.142L16.659 4.1a.112.112 0 0 0-.08-.033.124.124 0 0 0-.062.02l-1.441 1.037a.565.565 0 0 1-.615.025 6.782 6.782 0 0 0-1.792-.736.565.565 0 0 1-.418-.455l-.292-1.742a.108.108 0 0 0-.109-.092h-1.759c-.054 0-.1.037-.108.092l-.301 1.767a.572.572 0 0 1-.414.451 6.625 6.625 0 0 0-1.746.736.572.572 0 0 1-.619-.025l-1.44-1.028a.103.103 0 0 0-.064-.021c-.02 0-.05.004-.079.033L4.075 5.374a.114.114 0 0 0-.013.142l1.04 1.463c.13.18.143.417.03.61a6.681 6.681 0 0 0-.714 1.754.565.565 0 0 1-.456.418l-1.742.293a.108.108 0 0 0-.092.108v1.76c0 .053.038.1.092.108l1.767.3a.573.573 0 0 1 .451.414c.16.614.41 1.204.736 1.747a.572.572 0 0 1-.025.618L4.12 16.55a.113.113 0 0 0 .012.142l1.245 1.245c.03.03.063.034.08.034.02 0 .042-.009.063-.021l1.462-1.04a.55.55 0 0 1 .326-.105.58.58 0 0 1 .284.075c.539.31 1.115.548 1.713.702a.56.56 0 0 1 .413.451l.293 1.755a.108.108 0 0 0 .108.092h1.76c.054 0 .1-.037.108-.092l.297-1.755a.554.554 0 0 1 .413-.45 6.69 6.69 0 0 0 1.75-.728.565.565 0 0 1 .615.025l1.45 1.032a.097.097 0 0 0 .062.021c.021 0 .05-.004.08-.033l1.245-1.245a.114.114 0 0 0 .012-.142l-1.032-1.454a.565.565 0 0 1-.025-.614 6.688 6.688 0 0 0 .727-1.75.56.56 0 0 1 .451-.415l1.755-.292Z"
      stroke="#212c3a"
      strokeWidth={0.2}
    />
    <path
      clipRule="evenodd"
      d="M6.686 10.998a4.319 4.319 0 0 1 4.316-4.316 4.319 4.319 0 0 1 4.316 4.316 4.319 4.319 0 0 1-4.316 4.316 4.319 4.319 0 0 1-4.316-4.316Zm1.128 0a3.19 3.19 0 0 0 3.188 3.188 3.19 3.19 0 0 0 3.188-3.188 3.19 3.19 0 0 0-3.188-3.188 3.19 3.19 0 0 0-3.188 3.188Z"
      stroke="#212c3a"
      strokeWidth={0.2}
    />
  </svg>
);

export const FolderIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2z"
    />
  </svg>
);

export const BusinessQuickNavIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.996 14.522a.625.625 0 0 1-.625-.625v-2.114a.625.625 0 0 1 1.25 0v2.114c0 .345-.28.625-.625.625"
      clipRule="evenodd"
    />
    <mask
      id="business-quick-nav-a"
      width="18"
      height="10"
      x="1"
      y="3"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'luminance' }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M1.666 3.816h16.658v8.593H1.666z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#business-quick-nav-a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.916 9.494c1.98 1.076 4.477 1.665 7.075 1.665 2.603 0 5.103-.59 7.083-1.665V6.992c0-1.062-.859-1.926-1.916-1.926H4.84c-1.062 0-1.925.86-1.925 1.918zm7.075 2.915c-2.954 0-5.802-.715-8.016-2.012a.62.62 0 0 1-.309-.539V6.984a3.175 3.175 0 0 1 3.175-3.168h10.317a3.174 3.174 0 0 1 3.166 3.176v2.866a.63.63 0 0 1-.309.54c-2.214 1.296-5.064 2.01-8.024 2.01"
        clipRule="evenodd"
      />
    </g>
    <mask
      id="business-quick-nav-b"
      width="8"
      height="5"
      x="6"
      y="1"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'luminance' }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M6.453 1.667h7.084v3.397H6.453z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#business-quick-nav-b)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.912 5.064a.625.625 0 0 1-.626-.625v-.305c0-.671-.545-1.217-1.216-1.217H8.92c-.671 0-1.217.546-1.217 1.217v.305a.625.625 0 0 1-1.25 0v-.305A2.47 2.47 0 0 1 8.92 1.667h2.15a2.47 2.47 0 0 1 2.467 2.467v.305c0 .345-.28.625-.626.625"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.828 18.116H5.161a3.34 3.34 0 0 1-3.315-3.075l-.159-2.091a.626.626 0 0 1 .577-.671.634.634 0 0 1 .67.576l.158 2.09a2.085 2.085 0 0 0 2.07 1.921h9.666c1.08 0 1.989-.844 2.07-1.92l.158-2.09a.64.64 0 0 1 .67-.577.625.625 0 0 1 .576.67l-.158 2.092a3.34 3.34 0 0 1-3.316 3.075"
      clipRule="evenodd"
    />
  </svg>
);

export const TransactionsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M15.716 16.224h-7.22M15.716 12.037h-7.22M11.251 7.86H8.496"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m15.908 2.75-7.689.004c-2.76.017-4.469 1.833-4.469 4.603v9.196c0 2.784 1.722 4.607 4.506 4.607l7.689-.003c2.76-.017 4.47-1.834 4.47-4.604V7.357c0-2.784-1.723-4.607-4.507-4.607"
      clipRule="evenodd"
    />
  </svg>
);

export const MyAdsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m12.835 3.053 4.452.666c2.38.356 3.608 2.258 3.252 4.635l-.96 6.413c-.355 2.377-2.086 3.836-4.467 3.48l-4.45-.667c-2.38-.356-3.61-2.256-3.254-4.634l.96-6.414c.355-2.377 2.094-3.833 4.467-3.48"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m8.518 5.875-2.86.945c-2.289.753-3.188 2.833-2.425 5.121L5.258 18.1c.754 2.28 2.706 3.423 4.985 2.67l4.287-1.408c.717-.226 1.316-.608 1.752-1.09"
    />
  </svg>
);

export const MainSectionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.436 1C20.063 1 22.5 3.546 22.5 7.335v8.83c0 3.789-2.437 6.335-6.064 6.335H7.064C3.437 22.5 1 19.954 1 16.165v-8.83C1 3.546 3.437 1 7.064 1zm0 1.5H7.064C4.292 2.5 2.5 4.397 2.5 7.335v8.83C2.5 19.103 4.292 21 7.064 21h9.372C19.209 21 21 19.103 21 16.165v-8.83C21 4.397 19.209 2.5 16.436 2.5M7.121 9.203a.75.75 0 0 1 .75.75v6.86a.75.75 0 0 1-1.5 0v-6.86a.75.75 0 0 1 .75-.75m4.667-3.284a.75.75 0 0 1 .75.75V16.81a.75.75 0 0 1-1.5 0V6.67a.75.75 0 0 1 .75-.75m4.59 6.909a.75.75 0 0 1 .75.75v3.233a.75.75 0 0 1-1.5 0v-3.233a.75.75 0 0 1 .75-.75"
      clipRule="evenodd"
    />
  </svg>
);

export const PackagesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M17.857 20.417a3.393 3.393 0 0 0 3.393-3.391v-2.702a2.24 2.24 0 0 1-.001-4.478h.001v-2.7a3.39 3.39 0 0 0-3.388-3.396H6.144A3.394 3.394 0 0 0 2.75 7.142v2.791a2.163 2.163 0 0 1 2.239 2.152 2.237 2.237 0 0 1-2.233 2.239H2.75v2.7a3.39 3.39 0 0 0 3.391 3.393h11.716"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m12.372 9.063.616 1.247c.06.122.176.207.31.227l1.378.201c.34.05.476.468.23.707l-.996.97a.42.42 0 0 0-.12.367l.235 1.37a.414.414 0 0 1-.601.437l-1.231-.647a.41.41 0 0 0-.386 0l-1.23.647a.415.415 0 0 1-.602-.437l.235-1.37a.41.41 0 0 0-.12-.367l-.995-.97a.414.414 0 0 1 .229-.707l1.377-.201a.42.42 0 0 0 .312-.227l.615-1.247a.415.415 0 0 1 .744 0"
      clipRule="evenodd"
    />
  </svg>
);

export const BusinessBalanceIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M15.938 15.938A7.001 7.001 0 0 0 15 2a7 7 0 0 0-6.938 6.062M16 15a7 7 0 1 1-14 0 7 7 0 0 1 14 0"
    />
  </svg>
);

export const InvoicesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m16.936 19.902.76.364c.798.383 1.723-.2 1.722-1.087l-.01-12.254C19.408 4.502 18.06 3 15.642 3h-7.3C5.919 3 4.6 4.502 4.6 6.925l-.018 12.252a1.203 1.203 0 0 0 1.723 1.087l.754-.36a1.78 1.78 0 0 1 1.444-.044l2.146.875a3.57 3.57 0 0 0 2.7 0l2.143-.875c.466-.19.99-.175 1.444.042M9.256 14.453h5.108"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m9.666 9.839 1.542 1.542 3.156-3.156"
    />
  </svg>
);

export const WalletIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.888 15.896H17.84a3.446 3.446 0 0 1-3.442-3.44 3.447 3.447 0 0 1 3.442-3.442h4.048a.75.75 0 0 1 0 1.5H17.84a1.945 1.945 0 0 0-1.942 1.942c0 1.069.872 1.94 1.942 1.94h4.048a.75.75 0 0 1 0 1.5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.298 13.144h-.312a.75.75 0 0 1 0-1.5h.312a.75.75 0 0 1 0 1.5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.998 4.5A4.503 4.503 0 0 0 3.5 8.998v7.177a4.503 4.503 0 0 0 4.498 4.498h8.644a4.503 4.503 0 0 0 4.497-4.498V8.998A4.503 4.503 0 0 0 16.642 4.5zm8.644 17.673H7.998A6.005 6.005 0 0 1 2 16.175V8.998A6.005 6.005 0 0 1 7.998 3h8.644a6.004 6.004 0 0 1 5.997 5.998v7.177a6.004 6.004 0 0 1-5.997 5.998"
      clipRule="evenodd"
    />
  </svg>
);

export const ProfileIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    {...props}
  >
    <circle cx={21} cy={21} r={20} fill="#b1b8c6" stroke="#b1b8c6" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 1C9.955 1 1 9.954 1 21s8.955 20 20 20c11.046 0 20-8.954 20-20S32.046 1 21 1Zm0 5.98a6.616 6.616 0 1 1 0 13.232A6.616 6.616 0 0 1 21 6.98Zm-9.563 25.266a14.678 14.678 0 0 0 9.559 3.525c3.645 0 6.985-1.328 9.559-3.526a2.812 2.812 0 0 0 .988-2.142 6.662 6.662 0 0 0-6.693-6.67h-7.698c-3.705 0-6.704 2.966-6.704 6.67 0 .824.362 1.608.99 2.143Z"
      fill="#f6f7fa"
    />
  </svg>
);

export const Profile2Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 24}
    height={props.height ?? 24}
    fill="none"
    {...props}
  >
    <path
      fill="none"
      fillRule="evenodd"
      d="M4 14.496h15.84v7.374H4z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.921 15.996c-4.261 0-6.421.732-6.421 2.177 0 1.458 2.16 2.197 6.421 2.197 4.26 0 6.419-.732 6.419-2.177 0-1.458-2.159-2.197-6.419-2.197m0 5.874c-1.959 0-7.921 0-7.921-3.697 0-3.296 4.521-3.677 7.921-3.677 1.959 0 7.919 0 7.919 3.697 0 3.296-4.52 3.677-7.919 3.677"
      clipRule="evenodd"
    />
    <path
      fill="none"
      fillRule="evenodd"
      d="M6.61 2h10.62v10.619H6.61z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.92 3.428A3.887 3.887 0 0 0 8.037 7.31a3.873 3.873 0 0 0 3.854 3.882l.03.714v-.714A3.886 3.886 0 0 0 15.8 7.31a3.886 3.886 0 0 0-3.88-3.882m0 9.191h-.033A5.3 5.3 0 0 1 6.61 7.307 5.316 5.316 0 0 1 11.92 2a5.315 5.315 0 0 1 5.31 5.31 5.314 5.314 0 0 1-5.31 5.309"
      clipRule="evenodd"
    />
  </svg>
);

export const ExitIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M14.995 16.633v.943A3.68 3.68 0 0 1 11.319 21.25H6.433A3.687 3.687 0 0 1 2.75 17.565V6.436A3.687 3.687 0 0 1 6.433 2.75h4.875a3.69 3.69 0 0 1 3.686 3.686v.932"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M9.747 12h12.04"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="m18.86 8.866 3.144 3.134-3.144 3.134"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export const CheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.height || 16}
    height={props.height || 12}
    viewBox="0 0 16 12"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.84 1.167a1.01 1.01 0 1 1 1.395 1.461L5.948 11.5.765 6.549A1.01 1.01 0 0 1 2.16 5.087l3.787 3.618 7.891-7.538Z"
      fill={props.fill || '#212c3a'}
    />
  </svg>
);

export const CheckIconGradient = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.height || 17}
    height={props.height || 11}
    viewBox="0 0 17 11"
    fill="none"
    {...props}
  >
    <path
      d="M15.55 0.5L17 1.95728L8.5 10.5L2.5 4.40728L3.5 4L4.5 3.5L8.5 7.58543L15.55 0.5Z"
      fill="url(#paint0_linear_16119_10291)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_16119_10291"
        x1={9.75}
        y1={15.5}
        x2={0.402699}
        y2={1.94641}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fe5722" />
        <stop offset={0.52908} stopColor="#fe5631" />
        <stop offset={0.832941} stopColor="#fe5449" />
        <stop offset={1} stopColor="#fe6168" />
      </linearGradient>
    </defs>
  </svg>
);

export const SuccessIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={51}
    height={50}
    viewBox="0 0 51 50"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.5 0c6.677 0 12.956 2.6 17.677 7.323C47.9 12.044 50.5 18.323 50.5 25s-2.6 12.956-7.323 17.677C38.456 47.4 32.177 50 25.5 50s-12.956-2.6-17.677-7.323C3.1 37.956.5 31.677.5 25S3.1 12.044 7.823 7.323C12.543 2.6 18.822 0 25.5 0ZM3.43 25c0 12.17 9.9 22.07 22.07 22.07S47.57 37.17 47.57 25 37.67 2.93 25.5 2.93 3.43 12.83 3.43 25Z"
      fill="#3db460"
    />
    <path
      d="M37.567 16.694a1.454 1.454 0 0 0-2.093 0L22.405 30.088l-6.88-7.05a1.454 1.454 0 0 0-2.092 0 1.544 1.544 0 0 0 0 2.145l7.926 8.122a1.456 1.456 0 0 0 2.093 0L37.567 18.84a1.544 1.544 0 0 0 0-2.145Z"
      fill="#3db460"
    />
  </svg>
);

export const SuccessFilledIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fill="#3db460"
      d="M8.6 11.8 6.45 9.65a.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275.95.95 0 0 0-.275.7q0 .425.275.7L7.9 13.9q.3.3.7.3t.7-.3l5.65-5.65a.95.95 0 0 0 .275-.7.95.95 0 0 0-.275-.7.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275zM10 20a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137Q1.575 15.725.788 13.9A9.8 9.8 0 0 1 0 10q0-2.074.788-3.9a10.1 10.1 0 0 1 2.137-3.175Q4.275 1.575 6.1.788A9.8 9.8 0 0 1 10 0q2.075 0 3.9.788a10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.138 3.175A9.7 9.7 0 0 1 20 10a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.138A9.7 9.7 0 0 1 10 20"
    />
  </svg>
);

export const EWalletIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="35"
    fill="none"
    {...props}
  >
    <rect width="35" height="35" fill="#f6f7fa" rx="17.5" />
    <path
      fill="#4c88f9"
      d="M23.25 12.75a3.5 3.5 0 0 1 3.5 3.5v.438h-3.5a3.062 3.062 0 1 0 0 6.125h3.5v.437a3.5 3.5 0 0 1-3.5 3.5h-10.5a3.5 3.5 0 0 1-3.5-3.5v-10.5zm3.5 8.75h-3.5a1.75 1.75 0 1 1 0-3.5h3.5zM18 9.25a3.5 3.5 0 0 1 3.245 2.188H9.505A3.5 3.5 0 0 1 12.75 9.25z"
    />
  </svg>
);

export const InfoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={9} cy={9} r={9} fill="#fff" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.106 0a9.005 9.005 0 0 0-7.884 4.47 9.012 9.012 0 0 0 0 9.062A9.003 9.003 0 0 0 9.107 18a9 9 0 0 0 0-18Zm1.874 13.948c-.368.147-.736.287-1.108.419a2.955 2.955 0 0 1-.963.142c-.56 0-.996-.137-1.308-.41a1.321 1.321 0 0 1-.464-1.042c0-.165.011-.33.034-.502.023-.17.06-.362.112-.578l.579-2.048c.05-.197.095-.384.13-.556a2.43 2.43 0 0 0 .051-.483c0-.26-.053-.444-.16-.546-.109-.101-.315-.152-.62-.152a1.62 1.62 0 0 0-.46.067 6.504 6.504 0 0 0-.404.135l.152-.631c.381-.155.744-.287 1.091-.398a3.25 3.25 0 0 1 .983-.165c.557 0 .987.135 1.289.403.3.269.453.62.453 1.048 0 .09-.013.247-.032.47-.017.21-.057.418-.115.619l-.577 2.041a6.46 6.46 0 0 0-.127.56c-.038.21-.056.37-.056.478 0 .271.06.457.182.555.12.097.33.147.63.147.14 0 .298-.026.477-.074.177-.048.305-.092.385-.13l-.154.63ZM9.906 6.036c.36.007.71-.127.973-.376h-.001a1.19 1.19 0 0 0 .403-.908 1.215 1.215 0 0 0-.403-.912 1.372 1.372 0 0 0-.972-.378c-.378 0-.703.124-.975.378-.27.252-.406.556-.406.912-.003.348.144.68.406.908.272.25.598.376.975.376Z"
      fill="#4c88f9"
    />
  </svg>
);

export const InfoOutlinedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={51}
    height={50}
    viewBox="0 0 51 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="25.5" cy="25" r="23.5" stroke="#4C88F9" strokeWidth="3" />
    <path
      d="M24.4638 13.878C25.0508 13.2929 25.7608 13 26.5936 13C27.44 13 28.1491 13.2929 28.7225 13.878C29.3096 14.463 29.6035 15.1696 29.6035 15.9995C29.6035 16.8294 29.3096 17.537 28.7225 18.122C28.1355 18.7071 27.4264 19 26.5936 19C25.7745 19 25.0706 18.7071 24.4836 18.122C23.8965 17.537 23.6035 16.8294 23.6035 15.9995C23.6035 15.1696 23.8904 14.463 24.4638 13.878Z"
      fill="#4C88F9"
    />
    <path
      d="M29.4091 20C26.9523 20.3633 24.5002 20.5487 22.04 20.8916L21.7873 22.0172C22.0485 22.0046 22.2728 22.0128 22.4594 22.0128C22.8698 22.0128 23.1933 22.1209 23.4296 22.3373C23.6659 22.5536 23.7837 22.8021 23.7837 23.0821C23.7837 23.5275 23.6595 23.7392 23.4107 24.6174L20.8171 33.7431C20.6057 34.4686 20.5 35.0661 20.5 35.537C20.5 36.2497 20.7363 36.8415 21.209 37.3124C21.6941 37.7705 23.2115 38 24.02 38C26.1345 38 29.6218 36.8451 31.5 33.4978L29.9901 32.5974C29.2065 33.8319 27.791 34.7242 27.1438 35.1255C26.4462 35.4655 26.0662 35.442 25.8548 35.442C25.7304 35.442 25.6118 35.3842 25.4998 35.2697C25.3879 35.1424 25.3323 35.0095 25.3323 34.8696C25.3323 34.6278 25.4379 34.1185 25.6494 33.3422L29.4091 20Z"
      fill="#4C88F9"
    />
  </svg>
);

export const CloseWebviewIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 1.80419L13.6958 0.5L7.5 6.69581L1.30419 0.5L0 1.80419L6.19581 8L0 14.1958L1.30419 15.5L7.5 9.30419L13.6958 15.5L15 14.1958L8.80419 8L15 1.80419Z"
      fill="#8D94AD"
    />
  </svg>
);

export const AngleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="currentColor"
    {...props}
  >
    <path
      d="M1.02353 0.5L-2.6139e-07 1.5201L6 7.5L12 1.5201L10.9765 0.5L6 5.4598L1.02353 0.5Z"
      fill="currentColor"
    />
  </svg>
);

export const ProfileDefaultIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="currentColor"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 0C7.61214 0 0 7.61098 0 17C0 26.389 7.61139 34 17 34C26.3894 34 34 26.389 34 17C34 7.61098 26.3894 0 17 0ZM16.9999 5.08332C20.1063 5.08332 22.6235 7.6014 22.6235 10.7064C22.6235 13.8122 20.1063 16.3295 16.9999 16.3295C13.895 16.3295 11.3778 13.8122 11.3778 10.7064C11.3778 7.6014 13.895 5.08332 16.9999 5.08332ZM8.87182 26.5595C11.0605 28.4271 13.898 29.5555 16.9962 29.5555C20.0951 29.5555 22.9334 28.4271 25.1214 26.5587C25.6553 26.1039 25.9614 25.4386 25.9614 24.7381C25.9614 21.589 23.4226 19.0687 20.2721 19.0687H13.7293C10.5796 19.0687 8.03101 21.589 8.03101 24.7381C8.03101 25.4378 8.33866 26.1047 8.87182 26.5595Z"
      fill="currentColor"
    />
  </svg>
);

export const ChevronIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 10.45L19.5427 9L11 17.5L19.5427 26L21 24.55L13.9146 17.5L21 10.45Z"
      fill="currentColor"
    />
  </svg>
);

export const SmallChevronIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 12.8059L1.16583 14L8 7L1.16583 0L0 1.19411L5.66835 7L0 12.8059Z"
      fill="currentColor"
    />
  </svg>
);

export const ShareLinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    {...props}
  >
    <path
      stroke="#212C3A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m5.379 8.19-2.233 2.234a4.45 4.45 0 0 0 .047 6.343 4.45 4.45 0 0 0 3.18 1.352c1.22.01 2.329-.444 3.163-1.278l2.233-2.233m2.853-2.798 2.233-2.234a4.45 4.45 0 0 0-.047-6.343 4.536 4.536 0 0 0-3.18-1.325 4.405 4.405 0 0 0-3.162 1.278L8.232 5.42m-1.618 7.907 6.7-6.7"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity=".2"
      strokeWidth="2"
      d="m5.379 8.19-2.233 2.234a4.45 4.45 0 0 0 .047 6.343 4.45 4.45 0 0 0 3.18 1.352c1.22.01 2.329-.444 3.163-1.278l2.233-2.233m2.853-2.798 2.233-2.234a4.45 4.45 0 0 0-.047-6.343 4.536 4.536 0 0 0-3.18-1.325 4.405 4.405 0 0 0-3.162 1.278L8.232 5.42m-1.618 7.907 6.7-6.7"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity=".2"
      strokeWidth="2"
      d="m5.379 8.19-2.233 2.234a4.45 4.45 0 0 0 .047 6.343 4.45 4.45 0 0 0 3.18 1.352c1.22.01 2.329-.444 3.163-1.278l2.233-2.233m2.853-2.798 2.233-2.234a4.45 4.45 0 0 0-.047-6.343 4.536 4.536 0 0 0-3.18-1.325 4.405 4.405 0 0 0-3.162 1.278L8.232 5.42m-1.618 7.907 6.7-6.7"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity=".2"
      strokeWidth="2"
      d="m5.379 8.19-2.233 2.234a4.45 4.45 0 0 0 .047 6.343 4.45 4.45 0 0 0 3.18 1.352c1.22.01 2.329-.444 3.163-1.278l2.233-2.233m2.853-2.798 2.233-2.234a4.45 4.45 0 0 0-.047-6.343 4.536 4.536 0 0 0-3.18-1.325 4.405 4.405 0 0 0-3.162 1.278L8.232 5.42m-1.618 7.907 6.7-6.7"
    />
  </svg>
);

export const CopyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.12"
      d="M9.971 3.649C9.82 2.665 9.111 2 8.041 2H4.578c-1.206 0-1.964.857-1.964 2.067V8.53c0 1.103.63 1.915 1.664 2.043"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.12"
      d="M11.422 5.41H7.958c-1.207 0-1.964.854-1.964 2.063v4.464c0 1.21.753 2.064 1.964 2.064h3.463c1.212 0 1.965-.855 1.965-2.064V7.473c0-1.21-.753-2.064-1.964-2.064"
    />
  </svg>
);

export const UniversalPlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.width ?? 13}
    height={props.height ?? 12}
    viewBox="0 0 15 15"
    {...props}
  >
    <path
      fill={props.fill ?? '#212C3A'}
      d="M13.13 6.099H7.964V.932A.945.945 0 0 0 7.03 0 .945.945 0 0 0 6.1.932V6.1H.932A.945.945 0 0 0 0 7.03c0 .505.427.933.932.933H6.1v5.166c0 .505.427.932.932.932a.945.945 0 0 0 .933-.932V7.964h5.166a.945.945 0 0 0 .932-.933.945.945 0 0 0-.932-.932Z"
    />
    <path
      fill={props.fill ?? '#212C3A'}
      fillOpacity=".2"
      d="M13.13 6.099H7.964V.932A.945.945 0 0 0 7.03 0 .945.945 0 0 0 6.1.932V6.1H.932A.945.945 0 0 0 0 7.03c0 .505.427.933.932.933H6.1v5.166c0 .505.427.932.932.932a.945.945 0 0 0 .933-.932V7.964h5.166a.945.945 0 0 0 .932-.933.945.945 0 0 0-.932-.932Z"
    />
    <path
      fill={props.fill ?? '#212C3A'}
      fillOpacity=".2"
      d="M13.13 6.099H7.964V.932A.945.945 0 0 0 7.03 0 .945.945 0 0 0 6.1.932V6.1H.932A.945.945 0 0 0 0 7.03c0 .505.427.933.932.933H6.1v5.166c0 .505.427.932.932.932a.945.945 0 0 0 .933-.932V7.964h5.166a.945.945 0 0 0 .932-.933.945.945 0 0 0-.932-.932Z"
    />
    <path
      fill={props.fill ?? '#212C3A'}
      fillOpacity=".2"
      d="M13.13 6.099H7.964V.932A.945.945 0 0 0 7.03 0 .945.945 0 0 0 6.1.932V6.1H.932A.945.945 0 0 0 0 7.03c0 .505.427.933.932.933H6.1v5.166c0 .505.427.932.932.932a.945.945 0 0 0 .933-.932V7.964h5.166a.945.945 0 0 0 .932-.933.945.945 0 0 0-.932-.932Z"
    />
  </svg>
);

export const ExportIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 18}
    height={props.height ?? 18}
    fill="none"
    {...props}
  >
    <path
      stroke="#212C3A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M17.25 9v3.733c0 1.494 0 2.24-.29 2.811-.256.502-.664.91-1.166 1.165-.57.291-1.317.291-2.81.291H5.516c-1.494 0-2.24 0-2.811-.29a2.667 2.667 0 0 1-1.165-1.166c-.291-.57-.291-1.317-.291-2.81V9m11.556-4.444L9.25 1m0 0L5.694 4.556M9.25 1v10.667"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity=".2"
      strokeWidth="1.5"
      d="M17.25 9v3.733c0 1.494 0 2.24-.29 2.811-.256.502-.664.91-1.166 1.165-.57.291-1.317.291-2.81.291H5.516c-1.494 0-2.24 0-2.811-.29a2.667 2.667 0 0 1-1.165-1.166c-.291-.57-.291-1.317-.291-2.81V9m11.556-4.444L9.25 1m0 0L5.694 4.556M9.25 1v10.667"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity=".2"
      strokeWidth="1.5"
      d="M17.25 9v3.733c0 1.494 0 2.24-.29 2.811-.256.502-.664.91-1.166 1.165-.57.291-1.317.291-2.81.291H5.516c-1.494 0-2.24 0-2.811-.29a2.667 2.667 0 0 1-1.165-1.166c-.291-.57-.291-1.317-.291-2.81V9m11.556-4.444L9.25 1m0 0L5.694 4.556M9.25 1v10.667"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity=".2"
      strokeWidth="1.5"
      d="M17.25 9v3.733c0 1.494 0 2.24-.29 2.811-.256.502-.664.91-1.166 1.165-.57.291-1.317.291-2.81.291H5.516c-1.494 0-2.24 0-2.811-.29a2.667 2.667 0 0 1-1.165-1.166c-.291-.57-.291-1.317-.291-2.81V9m11.556-4.444L9.25 1m0 0L5.694 4.556M9.25 1v10.667"
    />
  </svg>
);

export const ChevronDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 15}
    height={props.height ?? 10}
    fill="none"
    {...props}
  >
    <path
      fill="#212C3A"
      d="M1.28.5 0 1.812 7.5 9.5 15 1.812 13.72.5 7.5 6.877 1.28.5Z"
    />
    <path
      fill="#000"
      fillOpacity=".2"
      d="M1.28.5 0 1.812 7.5 9.5 15 1.812 13.72.5 7.5 6.877 1.28.5Z"
    />
    <path
      fill="#000"
      fillOpacity=".2"
      d="M1.28.5 0 1.812 7.5 9.5 15 1.812 13.72.5 7.5 6.877 1.28.5Z"
    />
    <path
      fill="#000"
      fillOpacity=".2"
      d="M1.28.5 0 1.812 7.5 9.5 15 1.812 13.72.5 7.5 6.877 1.28.5Z"
    />
  </svg>
);

export const SortIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.width ?? 18}
    height={props.height ?? 15}
    viewBox="0 0 18 16"
    {...props}
  >
    <path
      fill="#212C3A"
      d="m4.764.508.043-.005L4.875.5l.056.002.095.013.083.023.083.033.074.039.078.055.061.055L9.53 4.845a.75.75 0 0 1-.99 1.123l-.07-.062L5.625 3.06v11.69a.75.75 0 0 1-1.495.088l-.005-.088V3.06L1.28 5.906a.75.75 0 0 1-.99.062l-.07-.062a.75.75 0 0 1-.063-.99l.063-.071L4.345.72a.75.75 0 0 1 .084-.073L4.51.594l.086-.04.079-.027.088-.019ZM13.125.5a.75.75 0 0 1 .745.662l.005.088v11.69l2.845-2.845.07-.062a.75.75 0 0 1 1.053 1.052l-.063.07-4.125 4.126-.033.03-.05.043-.083.053-.086.04-.078.027-.088.018-.068.008h-.088l-.045-.005-.086-.014-.081-.025-.061-.026-.074-.039-.072-.05a.753.753 0 0 1-.067-.06L8.47 11.156l-.062-.07a.75.75 0 0 1 0-.92l.062-.07.07-.063a.75.75 0 0 1 .92 0l.07.062 2.845 2.844V1.25l.005-.088A.75.75 0 0 1 13.125.5Z"
    />
    <path
      fill="#212C3A"
      fillOpacity=".2"
      d="m4.764.508.043-.005L4.875.5l.056.002.095.013.083.023.083.033.074.039.078.055.061.055L9.53 4.845a.75.75 0 0 1-.99 1.123l-.07-.062L5.625 3.06v11.69a.75.75 0 0 1-1.495.088l-.005-.088V3.06L1.28 5.906a.75.75 0 0 1-.99.062l-.07-.062a.75.75 0 0 1-.063-.99l.063-.071L4.345.72a.75.75 0 0 1 .084-.073L4.51.594l.086-.04.079-.027.088-.019ZM13.125.5a.75.75 0 0 1 .745.662l.005.088v11.69l2.845-2.845.07-.062a.75.75 0 0 1 1.053 1.052l-.063.07-4.125 4.126-.033.03-.05.043-.083.053-.086.04-.078.027-.088.018-.068.008h-.088l-.045-.005-.086-.014-.081-.025-.061-.026-.074-.039-.072-.05a.753.753 0 0 1-.067-.06L8.47 11.156l-.062-.07a.75.75 0 0 1 0-.92l.062-.07.07-.063a.75.75 0 0 1 .92 0l.07.062 2.845 2.844V1.25l.005-.088A.75.75 0 0 1 13.125.5Z"
    />
    <path
      fill="#212C3A"
      fillOpacity=".2"
      d="m4.764.508.043-.005L4.875.5l.056.002.095.013.083.023.083.033.074.039.078.055.061.055L9.53 4.845a.75.75 0 0 1-.99 1.123l-.07-.062L5.625 3.06v11.69a.75.75 0 0 1-1.495.088l-.005-.088V3.06L1.28 5.906a.75.75 0 0 1-.99.062l-.07-.062a.75.75 0 0 1-.063-.99l.063-.071L4.345.72a.75.75 0 0 1 .084-.073L4.51.594l.086-.04.079-.027.088-.019ZM13.125.5a.75.75 0 0 1 .745.662l.005.088v11.69l2.845-2.845.07-.062a.75.75 0 0 1 1.053 1.052l-.063.07-4.125 4.126-.033.03-.05.043-.083.053-.086.04-.078.027-.088.018-.068.008h-.088l-.045-.005-.086-.014-.081-.025-.061-.026-.074-.039-.072-.05a.753.753 0 0 1-.067-.06L8.47 11.156l-.062-.07a.75.75 0 0 1 0-.92l.062-.07.07-.063a.75.75 0 0 1 .92 0l.07.062 2.845 2.844V1.25l.005-.088A.75.75 0 0 1 13.125.5Z"
    />
    <path
      fill="#212C3A"
      fillOpacity=".2"
      d="m4.764.508.043-.005L4.875.5l.056.002.095.013.083.023.083.033.074.039.078.055.061.055L9.53 4.845a.75.75 0 0 1-.99 1.123l-.07-.062L5.625 3.06v11.69a.75.75 0 0 1-1.495.088l-.005-.088V3.06L1.28 5.906a.75.75 0 0 1-.99.062l-.07-.062a.75.75 0 0 1-.063-.99l.063-.071L4.345.72a.75.75 0 0 1 .084-.073L4.51.594l.086-.04.079-.027.088-.019ZM13.125.5a.75.75 0 0 1 .745.662l.005.088v11.69l2.845-2.845.07-.062a.75.75 0 0 1 1.053 1.052l-.063.07-4.125 4.126-.033.03-.05.043-.083.053-.086.04-.078.027-.088.018-.068.008h-.088l-.045-.005-.086-.014-.081-.025-.061-.026-.074-.039-.072-.05a.753.753 0 0 1-.067-.06L8.47 11.156l-.062-.07a.75.75 0 0 1 0-.92l.062-.07.07-.063a.75.75 0 0 1 .92 0l.07.062 2.845 2.844V1.25l.005-.088A.75.75 0 0 1 13.125.5Z"
    />
  </svg>
);

export const PaymentErrorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="25" cy="25" r="23.5" stroke="#FF586D" strokeWidth="3" />
    <path
      d="m16.406 17.188 17.188 16.406M33.594 17.188 16.406 33.593"
      stroke="#FF586D"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

export const EmailStatusConfirmedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="10"
    fill="none"
    {...props}
  >
    <path
      fill="#3DB460"
      d="M15.55 0 17 1.457 8.5 10l-6-5.95L4 2.55l4.5 4.535z"
    />
  </svg>
);

export const EmailStatusWarningIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fill="#FFB900"
      d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0m0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m0 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-9a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0V5a1 1 0 0 1 1-1"
    />
  </svg>
);

export const CloseFilledIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.9"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2649 10.2368L10.2363 11.2654L7.59144 8.6205L4.94654 11.2654L3.91797 10.2368L6.56287 7.59193L3.91797 4.94703L4.94654 3.91846L7.59144 6.56335L10.2363 3.91846L11.2649 4.94703L8.62001 7.59193L11.2649 10.2368ZM7.5 0C3.375 0 0 3.375 0 7.5C0 11.625 3.375 15 7.5 15C11.625 15 15 11.625 15 7.5C15 3.375 11.625 0 7.5 0Z"
      fill="white"
    />
  </svg>
);

export const DownloadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M3.33594 12.6703L3.33594 15.7438C3.33594 16.2095 3.51153 16.6562 3.82409 16.9856C4.13665 17.315 4.56058 17.5 5.0026 17.5H15.0026C15.4446 17.5 15.8686 17.315 16.1811 16.9856C16.4937 16.6562 16.6693 16.2095 16.6693 15.7438V12.6703M10.0035 2.5V12.4521M6.19401 8.64941L10.0035 12.4521L13.8131 8.64941"
      stroke="#4C88F9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
